import React, { Component, Fragment } from 'react';
import { localize } from 'react-localize-redux';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { createMuiTheme } from '@material-ui/core/styles';
import DialogTitle from '@material-ui/core/DialogTitle';
import { MuiThemeProvider } from '@material-ui/core';
import FlatButton from 'material-ui/FlatButton';
import Drawer from '@material-ui/core/Drawer';
import Dialog from '@material-ui/core/Dialog';

import AddMaintenanceTicketForm from './tickets/AddMaintenanceTicketForm';
import TicketDetailsOverview from './tickets/TicketDetailsOverview';

import { AccentColor } from 'helpers/AccentColorHelper';
import { drawerStyle } from 'helpers/tableHelpers';
import { colors } from 'helpers/ColorHelper';

let AddAndViewMaintenanceTickets = class extends Component {
  render() {
    return (
      <Fragment>
        {this.renderAddMaintenanceTicketDialog()}
        {this.renderMaintenanceTicketDetails()}
      </Fragment>
    );
  }

  renderAddMaintenanceTicketDialog = () => (
    <Dialog
      disableBackdropClick
      fullScreen={this.props.fullScreen}
      open={this.props.drawerIsOpen}
      onClose={this.props.toggleAddTicket}
      aria-labelledby="add-new-ticket"
    >
      <DialogTitle id="add-new-ticket">
        <h3 style={{ textAlign: 'center', margin: 0 }}>
          {this.props.translate('landlordPortal.addAndViewMaintenanceTickets.addNewTicket')}
        </h3>
      </DialogTitle>
      <DialogContent style={{ padding: 0 }}>
        <AddMaintenanceTicketForm
          onSubmit={this.props.addTicket}
          formName="add_ticket_form"
          initialValues={{ hide_from_tenant: false }}
        />
      </DialogContent>
      <DialogActions style={{ display: 'block' }}>
        <FlatButton
          onClick={this.props.toggleAddTicket}
          id="close-button"
          style={{ color: AccentColor() }}
        >
          {this.props.translate('landlordPortal.addAndViewMaintenanceTickets.cancel')}
        </FlatButton>
        <FlatButton
          variant="raised"
          onClick={this.props.submitMaintenanceTicket}
          disabled={this.props.submittingMaintenance}
          id="submit-button"
          style={{
            color: 'white',
            backgroundColor: this.props.submitting ? colors.LIGHT_GRAY : AccentColor(),
          }}
        >
          {this.props.translate('landlordPortal.addAndViewMaintenanceTickets.save')}
        </FlatButton>
      </DialogActions>
    </Dialog>
  );

  renderMaintenanceTicketDetails = () => (
    <MuiThemeProvider theme={createMuiTheme(drawerStyle)}>
      <Drawer open={this.props.showDrawer} onClose={this.props.toggleDrawer} anchor="left">
        <TicketDetailsOverview
          toggleDrawer={this.props.toggleDrawer}
          maintenanceTicket={this.props.maintenanceTicket}
          updateTicket={this.props.updateTicket}
          deleteAction={this.props.deleteAction}
          createOrUpdateTask={this.props.createOrUpdateTask}
          deleteTask={this.props.deleteTask}
          hideDelete={['cancelled_dup', 'cancelled'].includes(this.props.maintenanceTicket.status)}
          companyPreferences={this.props.companyPreferences}
        />
      </Drawer>
    </MuiThemeProvider>
  );
};

export default localize()(AddAndViewMaintenanceTickets);
